/* eslint-disable no-unused-vars */
import React, { memo } from 'react';
import { Box } from '@material-ui/core';
import ProductWorkbenchCanvas from '../ProductWorkbenchCanvas';
import { ImgProps, LayerChangeObject } from '../ProductWorkbenchCanvas/types';
import { ProductChanges } from './types';
import { Fade } from '../Fade';
import layout from '../../styles/layout.module.css';

const IEMPreview = ({
    event,
    width,
    height,
    layers,
    handleLayerChange,
    onLoad
}: {
    event: React.MouseEventHandler<HTMLElement>;
    dimensions: DOMRect;
    width: number;
    height: number;
    layers: ImgProps[];
    // layerChanges: ProductChanges;
    handleLayerChange: ([{ image, src, ...change }]: LayerChangeObject[]) => void;
    setLayerChanges: React.Dispatch<React.SetStateAction<ProductChanges>>;
    onBlob: (blob: string) => void;
    onLoad: any;
    // onFlip: () => void;
    // onMirror: () => void;
    // onReset: () => void;
}) => {
    return (
        <Box
            className={layout.iemPreviewBox}
            id="userDesign"
            onClick={event}
            style={{ height: '100%' }}>
            <Fade visible delay={230}>
                <ProductWorkbenchCanvas
                    dimensions={{ width, height }}
                    onChange={handleLayerChange}
                    layers={layers}
                    onLoad={onLoad}
                    canvasSizeByLayerId="leftShell"
                />
            </Fade>
        </Box>
    );
};

export default memo(IEMPreview);
